import { FormProvider, Resolver, SubmitHandler, useForm } from "react-hook-form";
import images from "../../../assets/images";
import ToasterWithMessage from "../../../components/toaster";
import './AdminClassroomForm.scss';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';
import ButtonStyle from "../../../components/ButtonStyle/ButtonStyle";
import InputField from "../../../components/InputField/InputField";
import Select, { StylesConfig } from 'react-select';
import { GET_TEACHERS_LIST } from "../../AdminDashboard/api/AdminDashboardQuery";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { CREATE_CLASSROOM, DELETE_CLASSROOM, EDIT_CLASSROOM } from "../api/AdminClassroomQuery";
import { FETCH_POLICY_NO_CACHE, MATERIALS_ALREADY_ASSOCIATED_TEXT, messages, patterns, VIRTUAL } from "../../../utils/constants";
import ConfirmationPopup from "../../../components/ConfirmationPopup/ConfirmationPopup";
import SubjectsPopUp from "../../../components/Popups/SubjectsPopup/SubjectsPopUp";
import { Tooltip } from "@mui/material";
import { getScreenDimensions } from "../../../utils/helper";
import { trackButtonClick } from "../../../firebase/analyticsHelper";
import { ButtonClickEvents } from "../../../firebase/constants/events";
import { useAppSelector } from "../../../redux/app/hooks";

interface propsType {
  setDisplayForm: any;
  displayForm: boolean;
  setClickAction?: any;
  clickAction?: any;
  classroomByIdDetails?: classroomByIdDetailsType;
  setisFullView: (value: boolean) => void;
  isFullView: boolean;
}

interface Subject {
  id: number;
  subjectName: string;
  subjectImageUrl: string;
}
interface IFormInput {
  classroomName: string;
  code: string;
  headTeacher: string;
  subjects: Subject[]|undefined;
  noofstudentaccess: string;
  agreedToTerms?: boolean;
}
interface Teacher {
  teacherId: string;
  teacherName: string;
  avatarUrl: string | null;
  mainSubject: any;
}

interface TeacherOption {
  value: string;
  label: string;
}

interface schoolAdminByIdNodesType {
  saId: string;
  saName: string;
  saNotificationEnabled: string;
  saWebsite: string;
  saEmailId: string;
  saDescription: string;
  saAvatarUrl: string;
}

interface teacherSubjectsByTIdNodesType {
  subjectBySjId: {
    sjName: string;
    sjOriginalName: string;
    sjId: string;
  }
}
interface teacherByUIdNodesType {
  tName: string;
  tId: string;
  tAvatarUrl: string;
  teacherSubjectsByTId: {
    nodes: teacherSubjectsByTIdNodesType[]
  }
}
interface nodesType {
  uId: string;
  uEmailId: string;
  uRole: string;
  uFullName: string;
  uUserName: string;
  uUserPassword: string;
  uPhoneNumber: string;
  uCognitoId: string;
  schoolAdminsByUId: {
    nodes: schoolAdminByIdNodesType[]
  }
  teachersByUId: {
    nodes: teacherByUIdNodesType[]
  }
}
export interface schoolAdmin {
  nodes: nodesType[]
};

interface Subjects {
  csAvatarUrl: string;
  subjectBySjId: {
    sjName: string;
    sjOriginalName?: string;
  }
}

interface teacherForEdit {
  tId: string;
  teacherByTId: {
    tName: string;
  }
}
interface classroomByIdDetailsType {
  cId: string;
  cCode: string;
  cName: string;
  cOriginalName: string;
  cStudentsCount: number;
  isShowVirtualClassroom: boolean;
  classroomSubjectsByCId: {
    nodes: Subjects[]
  };
  saId: string;
  teacherClassroomsByCId: {
    nodes: teacherForEdit[]
  }
}

const schema = yup.object().shape({
  classroomName: yup.string()
    .required('Name is required')
    // .matches(patterns?.alphaNumericSpace, messages?.validClassroomName)
    // .matches(patterns?.NotStartWithNumber,messages?.ClassroomNameNotStartWithNumber)
    .max(100, 'Name should not exceed 100 characters'),
  code: yup.string().required('Code is required')
    .uppercase()
    .length(6, 'Code must be exactly 6 characters')
    .matches(patterns?.onlyAlphaNumeric, messages?.validCode),
  headTeacher: yup.string()
    .required('Head Teacher is required'),
  noofstudentaccess: yup.string()
    .required('No. of Student access is required'),
  agreedToTerms: yup.boolean().optional(),
  subjects: yup.array().of(
    yup.object().shape({
      subjectName: yup.string()
        // .matches(patterns?.alphabetSpace, {
        //   message: messages?.validSubject,
        //   excludeEmptyString: true
        // })
        .max(100, 'Subject must be between 1 and 100 characters long')
        // .lowercase(),
    })
  ).min(1, 'Subject is required')
    .test('at-least-one-non-empty-subject', 'Subject is required', function (value) {
      if (!value) {
        return false; // Ensure value is defined
      }
      // Loop through the subjects array and check for at least one non-empty subject
      for (let i = 0; i < value?.length; i++) {
        if (value?.[i]?.subjectName?.trim() !== '') {
          return true; // At least one non-empty subject found
        }
      }
      return false; // No non-empty subjects found
    })
});

const AdminClassroomForm = ({ setDisplayForm, displayForm, setClickAction, clickAction, classroomByIdDetails, setisFullView, isFullView }: propsType) => {
  const [teacherData, setTeacherData] = useState<Teacher[]>([]);
  const [teacherOptions, setTeacherOptions] = useState<TeacherOption[]>([]);
  const { success, error } = ToasterWithMessage();
  const { UpArrow, DownArrow, backArrow, teacherDeleteIcon, DeleteGif, AddSubjectIcon, leftWhiteArrow, rightWhiteArrow,deleteIcon } = images;
  const [noOfStudents, setNoOfStudents] = useState<string>('0');
  const [subjectFieldError, setSubjectFieldError] = useState<string | null | undefined>('');
  const [isDisable, setIsDisable] = useState<boolean>(true);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [subjects, setSubjects] = useState<{ id: number, subjectName: string; subjectImageUrl: string }[]>([]);
  const [currentSubject, setCurrentSubject] = useState<{ id: number, subjectName: string|null; subjectImageUrl: string|null } | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [type,setType] = useState<string>('');
  const [loadingForm,setLoadingForm] = useState<boolean>(false);
  const studentLimit = process.env.REACT_APP_STUDENT_LIMIT ? parseInt(process.env.REACT_APP_STUDENT_LIMIT):100;
  const subjectLimit = process.env.REACT_APP_SUBJECT_LIMIT ? parseInt(process.env.REACT_APP_SUBJECT_LIMIT):10;
  const { isMobileScreen } = getScreenDimensions();
  const schoolType = useAppSelector((state) => state.auth.schoolType);
  
  const methods = useForm<IFormInput>({
    resolver: yupResolver(schema) as Resolver<IFormInput>,
    defaultValues: {
      classroomName: '',
      code: '',
      headTeacher: '',
      subjects:[{id: 0,
        subjectName: '',
        subjectImageUrl: ''}],
      noofstudentaccess: '0',
      agreedToTerms: false
    },
  });
  const { handleSubmit, setFocus, reset, register, getValues, setValue, trigger, clearErrors, watch, formState: { errors } } = methods;
  console.log(errors, "errors in classroomform")
  // const { fields , append, remove} = useFieldArray<IFormInput>({
  //   control: methods.control,
  //   name: 'subjects',
  // });

  const customStyle: StylesConfig = {
    control: (styles) => ({
      ...styles,
      cursor: 'pointer',
      borderRadius: '10px',
      width: `${isMobileScreen ? '100%' :'274px'}`,
      height: `${isMobileScreen ? '41px' :'27px'}`,
      padding: '0px',
      minHeight: `${isMobileScreen ? '41px' :'27px'}`,
      border: 'none',
      backgroundColor: `${isMobileScreen ? '#F0F3F5' : '#FFFFFF'}`
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: 'none'
    }),
    indicatorsContainer: (styles) => ({
      ...styles,
      padding: '0px 8px 0px 8px'
    }),
    input: (styles) => ({
      ...styles,
      fontFamily: 'Inter',
      fontWeight: '400',
      fontSize: '12px',
    }),
    placeholder: (styles) => ({
      ...styles,
      fontFamily: 'Inter',
      fontWeight: '400',
      fontSize: '12px',
      color: '#B1B1B1'
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isFocused ? '#f5f5f5' : isSelected ? '#e6e6e6' : undefined,
      color: '#333',
      fontFamily: 'Inter',
      fontWeight: isSelected ? '600' : '400',
      fontSize: '12px',
      cursor: 'pointer'
    }),
    singleValue: (styles) => ({
      ...styles,
      color: '#333',
      fontFamily: 'Inter',
      fontWeight: '400',
      fontSize: '12px',
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      color: '#2D2D2D',
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto'
    }),
  }

  const [getAllTeachersList, { loading: teacherloading }] = useLazyQuery(GET_TEACHERS_LIST, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      register('headTeacher');
      setTeacherData(data?.allTeachers?.nodes || [])
    },
    onError: (err) => {
      error(err?.message)
    }
  });


  const [createClassroom, { loading: createClassroomLoading }] = useMutation(CREATE_CLASSROOM, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      success(data?.createClassroomBySchoolAdmin?.message);
      setDisplayForm(!displayForm);
      setisFullView(!isFullView);
      reset();
      setSubjects([]);
      setCurrentSubject(null);
      setIsPopupOpen(false);
      setType('');
    },
    onError: (err) => {
      error(err?.message);
      if(err?.message?.includes(MATERIALS_ALREADY_ASSOCIATED_TEXT)){
        setTimeout(()=>{
          setDisplayForm(!displayForm);
          setisFullView(!isFullView);
          setClickAction('');
          reset();
          setSubjects([]);
          setCurrentSubject(null);
          setIsPopupOpen(false);
          setType('');   
        },2000);
     }
    }
  });

  const [editClassroom, { loading: editClassroomLoading }] = useMutation(EDIT_CLASSROOM, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      success(data?.editClassroom?.message);
      setDisplayForm(!displayForm);
      setisFullView(!isFullView);
      setClickAction('');
      reset();
      setSubjects([]);
      setCurrentSubject(null);
      setIsPopupOpen(false);
      setType('');
    },
    onError: (err) => {
      error(err?.message);
      if(err?.message?.includes(MATERIALS_ALREADY_ASSOCIATED_TEXT)){
        setTimeout(()=>{
          setDisplayForm(!displayForm);
          setisFullView(!isFullView);
          setClickAction('');
          reset();
          setSubjects([]);
          setCurrentSubject(null);
          setIsPopupOpen(false);
          setType('');   
        },2000);
     }
    }
  });

  const [deleteClassroom, { loading: deleteClassroomLoading }] = useMutation(DELETE_CLASSROOM, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      success(data?.deleteClassroomById?.message);
      setDisplayForm(!displayForm);
      setisFullView(!isFullView);
      setClickAction('');
      reset();
      setSubjects([]);
      setCurrentSubject(null);
      setIsPopupOpen(false);
      setType('');
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  useEffect(() => {
    setFocus('classroomName');
  }, [setFocus]);

  useEffect(() => {
    getAllTeachersList({
      variables: {
        orderBy: ["T_NAME_ASC"],
        searchInput: '%'
      }
    });
  }, []);

  useEffect(() => {
    getAllTeachersList({
      variables: {
        orderBy: ["T_NAME_ASC"],
        searchInput: '%'
      }
    });
  }, [classroomByIdDetails?.teacherClassroomsByCId]);

  useEffect(() => {
    setTeacherOptions(
      teacherData.map((teacher) => ({
        value: teacher.teacherId,
        label: teacher.teacherName
      }))
    );
  }, [teacherData]);

  useEffect(() => {
    if (clickAction === 'edit') {
      reset({
        classroomName: classroomByIdDetails?.cOriginalName,
        code: classroomByIdDetails?.cCode,
        subjects:classroomByIdDetails?.classroomSubjectsByCId?.nodes?.map((node, index) => ({
          id: index,
          subjectName: (node?.subjectBySjId?.sjOriginalName ?? node?.subjectBySjId?.sjOriginalName) || '',
          subjectImageUrl: node?.csAvatarUrl || '',
        })) || [],
        headTeacher: classroomByIdDetails?.teacherClassroomsByCId?.nodes?.[0]?.tId,
        noofstudentaccess: classroomByIdDetails?.cStudentsCount.toString(),
        agreedToTerms: classroomByIdDetails?.isShowVirtualClassroom || false,
      });
      setSubjects(
        classroomByIdDetails?.classroomSubjectsByCId?.nodes?.map((node, index) => ({
          id: index,
          subjectName: (node?.subjectBySjId?.sjOriginalName ?? node?.subjectBySjId?.sjOriginalName) || '',
          subjectImageUrl: node?.csAvatarUrl || '',
        })) || []
      );      
    }
  }, [clickAction]);

  const onSubmitForm: SubmitHandler<IFormInput> = data => {
    trackButtonClick(ButtonClickEvents?.CREATE_CLASS_SAVE_BUTTON_CLICK, {
      description: "User clicks the save button on admin classroom form"
    });

    console.log("data submitted", data);
    const filteredSubjects = data?.subjects?.filter(subject => subject.subjectName.trim() !== '');
    const variables = {
      input: {
        cName: data?.classroomName?.trim(),
        cCode: data?.code?.trim(),
        cStudentsCount: Number(data?.noofstudentaccess?.trim()) || 0,
        headTeacherId: data?.headTeacher?.trim(),
        isShowVirtualClassroom: data?.agreedToTerms || false,
        subjects: filteredSubjects?.map(subject => ({
          subjectName: subject.subjectName?.trim(),
          subjectAvatarUrl: subject.subjectImageUrl?.trim() || null,
        })),
      }
    };
    const editVariables = {
      input: {
        classroomId: classroomByIdDetails?.cId?.trim(),
        cName: data?.classroomName?.trim(),
        cCode: data?.code?.trim(),
        cStudentsCount: Number(data?.noofstudentaccess?.trim()) || 0,
        headTeacherId: data?.headTeacher?.trim(),
        isShowVirtualClassroom: data?.agreedToTerms || false,
        subjects: filteredSubjects?.map(subject => ({
          subjectName: subject.subjectName?.trim(),
          subjectAvatarUrl: subject.subjectImageUrl?.trim() || null,
        })),
      }
    };
    console.log("variables", variables, editVariables);
    if (clickAction === 'edit' && (areValuesDifferent(data)) && editClassroomLoading === false) {
      editClassroom({
        variables: editVariables
      })
    } else if(clickAction === 'edit' && (!areValuesDifferent(data))){
      error("There is no changes to update");
    }else if (clickAction === 'add' && createClassroomLoading === false) {
      createClassroom({
        variables
      })
    }
  }

  const watchedFields = watch(["classroomName", "code", "headTeacher", "noofstudentaccess"]);
  //To check the datas are differ 
  function areValuesDifferent(data: IFormInput) {
    const initialValues = {
      classroomName: classroomByIdDetails?.cOriginalName,
      code: classroomByIdDetails?.cCode,
      subjects:classroomByIdDetails?.classroomSubjectsByCId?.nodes?.map((node, index) => ({
        id: index,
        subjectName: (node?.subjectBySjId?.sjOriginalName ?? node?.subjectBySjId?.sjOriginalName) || '',
        subjectImageUrl: node?.csAvatarUrl || '',
      })) || [],
      headTeacher: classroomByIdDetails?.teacherClassroomsByCId?.nodes?.[0]?.tId,
      noofstudentaccess: classroomByIdDetails?.cStudentsCount.toString(),
      agreedToTerms: classroomByIdDetails?.isShowVirtualClassroom
    };

   const initialValuesSubjects =
      classroomByIdDetails?.classroomSubjectsByCId?.nodes?.map((node, index) => ({
        id: index,
        subjectName: (node?.subjectBySjId?.sjOriginalName ?? node?.subjectBySjId?.sjOriginalName) || '',
        subjectImageUrl: node?.csAvatarUrl || '',
      })) || [];

    // Compare classroomName, code, headTeacher and noofstudentaccess
    if (data.classroomName !== initialValues.classroomName) {
      return true;
    }
    if (data.code !== initialValues.code) {
      return true;
    }
    if (data.headTeacher !== initialValues.headTeacher) {
      return true;
    }
    if (data.noofstudentaccess !== initialValues.noofstudentaccess) {
      return true;
    }
    
    if(data?.agreedToTerms !== initialValues.agreedToTerms){
      return true;
    }

    // Compare the subjects array
    if (data?.subjects?.length !== initialValuesSubjects.length) {
      return true;
    }

    for (let i = 0; i < subjects.length; i++) {
      if (data?.subjects[i].subjectName !== initialValuesSubjects[i].subjectName) {
        return true;
      }
      if (data?.subjects[i].subjectImageUrl !== initialValuesSubjects[i].subjectImageUrl) {
        return true;
      }
    }

    return false;
  }

  //To handle change student count
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputData = e.target.value;
    if (patterns?.onlyNumbers?.test(inputData)) {
      if (parseInt(inputData) <= studentLimit && parseInt(inputData) >= 0) {
        setValue('noofstudentaccess', inputData);
        setNoOfStudents(inputData);
        trigger('noofstudentaccess');
      } else {
        setNoOfStudents(noOfStudents);
        setValue('noofstudentaccess', noOfStudents.toString());
        trigger('noofstudentaccess');
      }
    } else {
      setNoOfStudents(noOfStudents);
      setValue('noofstudentaccess', noOfStudents.toString());
      trigger('noofstudentaccess');
    }
  };

  //To remove last value in input
  const handleKeyDown = (e: any) => {
    if (e.key === 'Backspace') {
      if (methods.getValues('noofstudentaccess').length === 1) {
        setNoOfStudents('0');
        setValue('noofstudentaccess', '');
        trigger('noofstudentaccess')
      }
    }
  }

  //To increase the student count
  const handleIncrease = () => {
    const currentValue = Number(methods.getValues('noofstudentaccess'));
    if (clickAction === 'edit') {
      if (currentValue < studentLimit && isDisable === false) {
        const newValue = currentValue + 1;
        setValue('noofstudentaccess', newValue.toString());
        setNoOfStudents(newValue.toString());
        trigger('noofstudentaccess')
      }
    } else {
      if (currentValue < studentLimit) {
        const newValue = currentValue + 1;
        setValue('noofstudentaccess', newValue.toString());
        setNoOfStudents(newValue.toString());
        trigger('noofstudentaccess')
      }
    }

  };

  //To decrease the student count
  const handleDecrease = () => {
    const currentValue = Number(methods.getValues('noofstudentaccess'));
    if (clickAction === 'edit') {
      if (currentValue > 0 && isDisable === false) {
        const newValue = currentValue - 1;
        setValue('noofstudentaccess', newValue.toString());
        setNoOfStudents(newValue.toString());
        trigger('noofstudentaccess')
      }
    } else {
      if (currentValue > 0) {
        const newValue = currentValue - 1;
        setValue('noofstudentaccess', newValue.toString());
        setNoOfStudents(newValue.toString());
        trigger('noofstudentaccess')
      }
    }
  };

  //To delete the classroom
  const handleDelete = (cId: string) => {
    if (deleteClassroomLoading === false) {
      setOpenConfirmationPopup(true);
    }
  };

  // click yes button in confirmation popup
  const onYesButtonClick = () => {
    setOpenConfirmationPopup(false);
    deleteClassroom({
      variables: {
        input: {
          classroomId: classroomByIdDetails?.cId
        }
      }
    });
  }

  // click no button in confirmation popup
  const onNoButtonClick = () => {
    setOpenConfirmationPopup(false);
  }
 
  const handleClosePopUp = () =>{
    setIsPopupOpen(false);
    setLoadingForm(false);
   setType('');
   setCurrentSubject(null);
  }

  useEffect(()=>{
    setType('');
    setCurrentSubject(null);
  },[subjects]);

  // Handle form submission when Enter key is pressed
  const handleKeyEnter = (e: { key: string; }) => {
    if (e.key === 'Enter') {
      handleSubmit(onSubmitForm)();
    }
  };

  const titleRef = useRef<HTMLDivElement | null>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const checkOverflow = () => {
    if (titleRef.current) {
      setIsOverflow(titleRef.current.scrollWidth > titleRef.current.clientWidth);
    }
  };

  console.log("schoolType", schoolType);

  return (
    <div className='adminClassroomForm'>
      <div className='adminClassroomFormHeader'>
        <img
          onClick={() => { 
            setDisplayForm(!displayForm);
            setisFullView(!isFullView);
            setClickAction('');
            reset();
            setSubjects([]);
            setCurrentSubject(null);
            setIsPopupOpen(false);
            setType('');}}
          className="backArrow"
          alt="back-arrow"
          src={backArrow}
        />
        <div className="AddClassroomformTitle">
          {clickAction === 'add' ?

            <label className='formTitleLabel' title='Class'>{isMobileScreen ? "Add Classroom" : "Adding Class"}</label>
            :
            <div className='statusContainer'>
             <Tooltip title={classroomByIdDetails?.cOriginalName} disableHoverListener={!isOverflow} placement="top">
                <div
                  ref={titleRef}
                  onMouseEnter={checkOverflow} 
                  className="formTitleLabelEdit"
                >
                  {classroomByIdDetails?.cOriginalName || ""}
                </div>
              </Tooltip>              {/* <div className='dotStyle' style={{backgroundColor: teacherByIdDetails?.tActive ? '#51CD3D' : 'red'}}></div> */}
              <div className='dotStyle' style={{ backgroundColor: '#51CD3D' }}></div>
            </div>
          }
        </div>
      </div>
      <div className="adminClassroomFormContainer">
        <FormProvider {...methods}>
          <form className="addClassroomForm" onSubmit={handleSubmit(onSubmitForm)} noValidate onKeyDown={handleKeyEnter}>
            <div className="classroomDetails">
              <div className="classNameField">
                <label className="nameOfClass">Name of Class</label>
                <InputField label="Name" name="classroomName" classname="subjectStyle" type="text" size="addClassroomField" isDisable={isDisable && clickAction === 'edit'} />
              </div>
              <div className="classCodeField">
                <label className="codeOfClass">Class Code</label>
                <InputField label="Code" name="code" classname="classCode" type="text" size="addClassroomField" isDisable={isDisable && clickAction === 'edit'} />
              </div>
              <div className="headTeacherField">
                <label className="headTeacherOfClass">Head Teacher</label>
                <Select
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      const option = selectedOption as TeacherOption;
                      methods.setValue('headTeacher', option.value);
                      clearErrors('headTeacher');
                    } else {
                      methods.setValue('headTeacher', '');
                    }
                  }}
                  isLoading={teacherloading}
                  isDisabled={isDisable && clickAction === 'edit'}
                  value={teacherOptions.find(option => option.value === getValues('headTeacher')) || null}
                  placeholder={watchedFields['2'] === '' ? 'Select Teacher' : ''}
                  classNamePrefix="dropdown-indicator"
                  styles={customStyle}
                  options={teacherOptions}
                />
                {errors['headTeacher'] && <span className="error-message">{errors?.headTeacher?.message}</span>}
              </div>
              {/* <div className="subjectsField">
                <label className="subjectsOfClass">Subjects</label>
                <div className="subject-inputs">
                  {fields.map((field, index) => (
                    <Controller
                      key={field.id}
                      name={`subjects.${index}.subject`}
                      control={methods.control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="field subject-field"
                          placeholder={`Add`}
                          disabled={isDisable && clickAction === 'edit'}
                          onChange={(e) => {
                            field.onChange(e);
                            trigger('subjects');
                            trigger(`subjects.${index}.subject`); // Trigger validation for each subject field
                          }}
                        />
                      )}
                    />
                  ))}
                </div>
                {(errors?.subjects?.root?.message && !subjectFieldError) && <span className="error-message">{errors?.subjects?.root?.message}</span>}
                {(errors?.subjects?.message && !errors?.subjects?.root?.message && !subjectFieldError) && <span className="error-message">{errors?.subjects?.message}</span>}
                {subjectFieldError && <span className="error-message">{subjectFieldError}</span>}
              </div> */}
              <div className="subjectsField">
                <label className="subjectsOfClass">Subjects</label>
                <div className="subject-inputs">
                  {
                    subjects?.length === 0 ? 
                    <div
                      key={0}
                      className={(isDisable && clickAction === 'edit') ? "subject-field-disabled" : "subject-field"}
                      style={{color:'#999'}}
                      onClick={() => {
                        if(!(isDisable && clickAction === 'edit')){
                        setType('addSubject');
                        setLoadingForm(true);
                        setCurrentSubject({
                          id: subjects.length + 1,
                          subjectName: null,
                          subjectImageUrl: null
                        });
                        setIsPopupOpen(true);
                      }
                      }}
                    >
                      {'Add'}
                    </div>
                    :
                    subjects?.map((subject, index) => (
                      <div
                        key={index}
                        className={(isDisable && clickAction === 'edit') ? "subject-field-disabled" :"subject-field"}
                        // disabled={isDisable && clickAction === 'edit'} 
                        onClick={() => {
                          if(!(isDisable && clickAction === 'edit')){
                          setType('editSubject');
                          setLoadingForm(true);
                          setCurrentSubject(subject);
                          setIsPopupOpen(true);
                          }
                        }}
                      >
                        <div className="subject-field-inner">
                        {subject?.subjectName}
                        </div>
                      </div>
                    ))
                  }
                  {subjects?.length < subjectLimit && <div
                    className={(isDisable && clickAction === 'edit') ? "add-subject-disabled" : "add-subject-button"}
                    // disabled={isDisable && clickAction === 'edit'} 
                    onClick={() => {
                      if(!(isDisable && clickAction === 'edit')){
                      setType('addSubject');
                      setLoadingForm(true);
                      setCurrentSubject({
                        id: subjects.length + 1,
                        subjectName: null,
                        subjectImageUrl: null
                      });
                      setIsPopupOpen(true);
                    }
                    }}
                  >
                    <img src={AddSubjectIcon} alt="Add" className="add-icon" />
                  </div>}
                </div>
                {(errors?.subjects?.root?.message && !subjectFieldError) && <span className="error-message">{errors?.subjects?.root?.message}</span>}
                {(errors?.subjects?.message && !errors?.subjects?.root?.message && !subjectFieldError) && <span className="error-message">{errors?.subjects?.message}</span>}
                {subjectFieldError && <span className="error-message">{subjectFieldError}</span>}
              </div>
              <div className="NoOFStudentsField">
                <div className="NoOFStudentsInput">
                  {isMobileScreen ?
                  <div className="input-container-noofstudentaccess">
                    <div className="rightArrowCtn"><img src={leftWhiteArrow} alt="down-arrow" className="downArrow" onClick={handleDecrease} /></div>
                    <input
                      id={"noofstudentaccess"}
                      {...register("noofstudentaccess")}
                      type={"text"}
                      placeholder={'0'}
                      className="field"
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      disabled={isDisable && clickAction === 'edit'}
                    />
                    <div className="leftArrowCtn"><img src={rightWhiteArrow} alt="up-arrow" className="upArrow" onClick={handleIncrease} /></div>
                  </div>
                  :
                  <div className="input-container-noofstudentaccess">
                    <input
                      id={"noofstudentaccess"}
                      {...register("noofstudentaccess")}
                      type={"text"}
                      placeholder={'0'}
                      className="field"
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      disabled={isDisable && clickAction === 'edit'}
                    />
                    <div className="count-container">
                      <div><img src={UpArrow} alt="up-arrow" className="upArrow" onClick={handleIncrease} /></div>
                      <div><img src={DownArrow} alt="down-arrow" className="downArrow" onClick={handleDecrease} /></div>
                    </div>
                  </div>
                  }
                  <label className="studentAccessClass">No. of Student access</label>
                </div>
                <div>
                  {errors['noofstudentaccess'] && <span className="error-message">{errors?.noofstudentaccess?.message}</span>}
                </div>
              </div>
              {(schoolType === VIRTUAL) && <div className="checkboxField">
                <input
                  id="agreedToTerms"
                  type="checkbox"
                  {...register("agreedToTerms")}
                  disabled={isDisable && clickAction === 'edit'}
                  className="checkboxInput"
                />
                <label htmlFor="agreedToTerms" className="checkboxLabel">Show on Landing Page</label>
              </div>}
              {isMobileScreen && (
                clickAction === 'edit' ?
                  isDisable ? <></> :
                    <ButtonStyle paddingLeft='16px' paddingRight='15px' width={'62px'} height={'35px'} color='var(--color-black)' bgcolor="white" variant='outlined' disableButton={deleteClassroomLoading || loadingForm} onClick={() => handleDelete(classroomByIdDetails?.cId ? classroomByIdDetails?.cId : '')} deleteBtn={<img src={teacherDeleteIcon} alt="deleteIcon" className='deleteIconStyle' />} />
                  :
                  <ButtonStyle paddingLeft='16px' paddingRight='15px' width={'62px'} height={'35px'} color='var(--color-black)' bgcolor="white" variant='outlined' text="Clear"
                    onClick={() => {
                      trackButtonClick(ButtonClickEvents?.CREATE_CLASS_CLEAR_BUTTON_CLICK, {
                        description: "User clicks the clear button on admin classroom form"
                      });
                      reset();
                      setSubjects([]);
                      setCurrentSubject(null);
                      setIsPopupOpen(false);
                      setType('');
                    }} type="reset" />
              )}
            </div>
            {
              clickAction === 'edit' ?
                isDisable ?
                  <div className="editClassroomFormButton">
                    <ButtonStyle paddingLeft='26px' paddingRight='28px' width={isMobileScreen ? '98%' :'83.25px'} height={isMobileScreen ? '35px': '23.92px'} text="Edit" onClick={() => setIsDisable(false)} />
                  </div> :
                  <div className="classroomFormButton">
                    {!isMobileScreen && <ButtonStyle paddingLeft='16px' paddingRight='15px' width={isMobileScreen ? '100%' : '62px'} height={isMobileScreen ? '35px':'23.92px'} color='var(--color-black)' bgcolor="#EBEBEB" variant='outlined' disableButton={deleteClassroomLoading||loadingForm} onClick={() => handleDelete(classroomByIdDetails?.cId ? classroomByIdDetails?.cId : '')} deleteBtn={<img src={isMobileScreen ? deleteIcon : teacherDeleteIcon} alt="deleteIcon" className='deleteIconStyle' />} />}
                    <ButtonStyle paddingLeft='26px' paddingRight='28px' width={isMobileScreen ? '100%' : '83.25px'} height={isMobileScreen ? '35px':'23.92px'} text="Save" disableButton={editClassroomLoading||loadingForm} type="submit" />
                  </div> :
                <div className="classroomFormButton">
                  {!isMobileScreen &&
                    <ButtonStyle paddingLeft='16px' paddingRight='15px' width={'62px'} height={'23.92px'} color='var(--color-black)' bgcolor="#EBEBEB" variant='outlined' text="Clear" 
                  onClick={() => {
                    reset();
                    setSubjects([]);
                    setCurrentSubject(null);
                    setIsPopupOpen(false);
                    setType('');
                      }} type="reset" />}
                  <ButtonStyle paddingLeft='26px' paddingRight='28px' width={isMobileScreen ? '100%' : '83.25px'} height={isMobileScreen ? '35px':'23.92px'} text="Save" disableButton={createClassroomLoading||loadingForm} type="submit" />
                </div>
             }
          </form>
          <ConfirmationPopup
            open={openConfirmationPopup}
            message={`Are you sure you want to Delete this classroom?`}
            gifData={DeleteGif}
            yesButtonFunctionality={onYesButtonClick}
            noButtonFunctionality={onNoButtonClick}
            messageWidth={'195px'}
          />
          <SubjectsPopUp
            subject={currentSubject}
            open={isPopupOpen}
            handleClosePopUp={handleClosePopUp}
            type={type}
            onSaveSubject={(id: number, subjectName: string, subjectImageUrl: string) => {
              if (type === 'addSubject') {
                // Add a new subject
                clearErrors('subjects');
                setSubjects((prev) => {
                  const newSubject = { id, subjectName, subjectImageUrl };
                  const updatedSubjects = [...prev, newSubject];
                  setValue('subjects', updatedSubjects); // Update form value
                  return updatedSubjects;
                });
                setLoadingForm(false);
              } else if (type === 'editSubject') {
                // Update the existing subject
                clearErrors('subjects');
                setSubjects((prev) => {
                  const updatedSubjects = prev.map((subject) =>
                    subject.id === id ? { ...subject, subjectName, subjectImageUrl } : subject
                  );
                  setValue('subjects', updatedSubjects); // Update form value
                  return updatedSubjects;
                });
                setLoadingForm(false);
              }
              setIsPopupOpen(false);
            }}
            onDeleteSubject={(id: number) => {
              // Delete the selected subject
              clearErrors('subjects');
              setSubjects((prev) => {
                const updatedSubjects = prev
                  .filter((subject) => subject.id !== id)
                  .map((subject) => {
                    if (subject.id === id) {
                      return { ...subject, imageUrl: '' };
                    }
                    return subject;
                  });
            
                setValue('subjects', updatedSubjects);
                return updatedSubjects;
              });
              setLoadingForm(false);
              setIsPopupOpen(false);
            
            }}            
          />
        </FormProvider>
      </div>
    </div>
  )
}

export default AdminClassroomForm;
